import React from "react";
import styled from "styled-components";
import {
  BuildingWrapper,
  SchedulerBuildingRef,
  SchedulerLayout,
} from "@sonder/ui/source/styled/layouts/SchedulerLayout";
import {
  GetTaskSchedulesBuilding,
  GetTaskSchedulesPlace,
} from "core/queries/GetTaskSchedules";
import { PlaceList } from "schedule/components/PlaceList";
import { ScheduleTimeColumns } from "schedule/components/ScheduleTimeColumns";
import { SchedulerRow } from "schedule/components/SchedulerRow";
import { useStore } from "schedule/store";

const Places = styled.div`
  position: relative;
`;
interface BuildingListItemProps {
  building: GetTaskSchedulesBuilding;
  places: GetTaskSchedulesPlace[] | undefined;
}
export const BuildingListItem = ({
  building,
  places,
}: BuildingListItemProps) => {
  const {
    state: { dateRange },
  } = useStore();
  return (
    <BuildingWrapper>
      <SchedulerLayout>
        <SchedulerBuildingRef>{building.shortInternalRef}</SchedulerBuildingRef>
        <PlaceList places={places} />
        <Places>
          <ScheduleTimeColumns
            endAt={dateRange.endAt}
            startAt={dateRange.startAt}
          />
          {places &&
            places.map(place => <SchedulerRow key={place.id} place={place} />)}
        </Places>
      </SchedulerLayout>
    </BuildingWrapper>
  );
};
